import { render } from "./StackedCards.vue?vue&type=template&id=7347bce2&ts=true"
import script from "./StackedCards.vue?vue&type=script&lang=ts"
export * from "./StackedCards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__